const layout = () => import("../../gerente/layout.vue");
const faturamentoGerente = () => import("./faturamentoGerente.vue");
const faturamentoDetalhe = () => import("./faturamentoDetalhe.vue");

const faturamentoGerenteRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "faturamentoGerente",
      component: faturamentoGerente,
    },
    {
      path: "/faturamentoDetalhe",
      name: "faturamentoDetalhe",
      component: faturamentoDetalhe,
    },
  ],
};

export default faturamentoGerenteRoutes;